<template>
<div class="polymerization" :class="{'haveBotnav':haveBotnav}" :style="!share.contentFloat?bgStyle:''">
    <shareConfig :datas="share" v-if="share.backType=='lbt'"></shareConfig>
    <div class="bgFixed" :style="bgStyle" v-else-if="share.contentFloat"></div>
    <div class="haveHeadPic" v-if="haveHeadPic"></div>
    <div :class="{'components_box':share.backType=='lbt'}">
        <div v-for="(slot, i) in page" :key="slot">
             <div v-if="slot.type == 'assets'">
                <user-assets :datas="slot">
                </user-assets>
            </div>
             <div v-if="slot.type === 'sound'">
                <audio-text :datas="slot"></audio-text>
            </div>
            <div v-if="slot.type === 'btGroup'">
                 <button-group :datas="slot"></button-group>
            </div>
            <div v-if="slot.type === 'telephone'">
                <telephone :datas="slot"></telephone>
            </div>
            <div v-if="slot.type === 'diyGoods'">
                <diyGoods :datas="slot"></diyGoods>
            </div>
            <div v-if="slot.type === 'rightsCenter'">
                <rightsCenter :datas="slot" :receivedList="receivedList"></rightsCenter>
            </div>
            <div v-if="slot.type === 'elevator'">
                <Elevator :datas="slot"></Elevator>
            </div>
            <div v-if="slot.type === 'headPic'">
                <HeadPic :datas="slot"></HeadPic>
            </div>
            <div v-if="slot.type === 'area'">
                <Area @updateArea="updateArea" :datas="slot"></Area>
            </div>
            <!-- 轮播图 -->
            <!-- 与区域code匹配，无区域组件，组件code未配置 -->
            <div v-if="slot.type === 'image'">
                <CarouselSlide :datas="slot"></CarouselSlide>
            </div>
            <div v-if="slot.type === 'active'">
                <Activity :datas="slot"></Activity>
            </div>
            <!-- 搜索 -->
            <div v-if="slot.type === 'search'">
                <Search :datas="slot"></Search>
            </div>
            <!-- 链接 -->
            <div v-if="slot.type === 'columnModule'&&!slot.isBottom">
                <Category :datas="slot"></Category>
            </div>
            <!-- 滚动内容 -->
            <div v-if="slot.type === 'messagenotice' && slot.items">

                <ScrollNotice :datas="slot"></ScrollNotice>
            </div>

            <!-- 限时抢购 -->
            <div v-if="slot.type === 'flashsale'">
                <Flashsale :datas="slot" :templateId="templateId"></Flashsale>
            </div>

            <!-- 产品列表 -->
            <div v-if="slot.type === 'goodList'">
                <GoodsList :datas="slot" :templateId="templateId"></GoodsList>
            </div>
            <div v-if="slot.type === 'advertising'">
                <Advertising :datas="slot"></Advertising>
            </div>
            <div v-if="slot.type === 'notice'">
                <notice :datas="slot"></notice>
            </div>
            <!-- 标题 -->
            <div v-if="slot.type === 'title'">
                <Title :datas="slot"></Title>
            </div>

            <!-- margin -->
            <div v-if="slot.type === 'whitespace'">
                <div :style="{height: slot.num + 'px',background: slot.color}"></div>
            </div>
            <!-- textarea -->
            <div v-if="slot.type === 'textarea'">
                <div :style='{"padding":"0 "+slot.padding+"px"}' class="textarea">
                    <v-html :content="slot.text"></v-html>
                </div>
            </div>
            <!-- 辅助线 -->
            <div v-if="slot.type === 'coupon'">
                <couponReceive :datas="slot"></couponReceive>
            </div>
            <!-- 视频 -->
            <div v-if="slot.type === 'video'">
                <videoBox :datas="slot"></videoBox>
            </div>
            <!-- 领取优惠券 -->
            <div v-if="slot.type === 'whiteLine'">
                <AuxiliaryLine :datas="slot"></AuxiliaryLine>
            </div>
            <!-- bottom nav -->

            <div v-if="slot.type === 'columnModule'&&slot.isBottom">
                <Navbar :datas="slot"></Navbar>
            </div>
            <!-- 客服 -->
            <div v-if="slot.type === 'cs'">
                <customerService :datas="slot"></customerService>
            </div>
            <!-- 天气 -->
            <div v-if="slot.type === 'weather'">
                <Weather :datas="slot" :hotelCode="hotelCode"></Weather>
            </div>
            <!-- 登录 -->
            <div v-if="slot.type === 'login'&&(!user||!user.memberId)">
                <Login :datas="slot"></Login>
            </div>
            <!-- 种草笔记 -->
            <div v-if="slot.type === 'plantGrass'">
                <plantGrass :datas="slot"></plantGrass>
            </div>
            <!-- 酒店商品 -->
            <div v-if="slot.type === 'hotelGoods'&&config.hotelCode=='0'">
                <hotelGoods></hotelGoods>
            </div>
            <div v-if="slot.type === 'sideBar'">
                <sideBar :datas="slot"></sideBar>
            </div>
            <div v-if="slot.type === 'navMenu'">
                <NavMenu :datas="slot"></NavMenu>
            </div>
            <div v-if="slot.type === 'groupList'">
                <groupList :datas="slot"></groupList>
            </div>
            <div v-if="slot.type === 'goodsType'">
                <goodsType :datas="slot"></goodsType>
            </div>
            <!-- 酒店预订 -->
            <div v-if="slot.type === 'hotelRoom'">
                <hotelRoom :datas="slot"></hotelRoom>
            </div>
             <div v-if="slot.type === 'receivedCouponLayer'">
                <guide-layer :couponActivityConfig="slot"></guide-layer>
            </div>
            <div v-if="slot.type === 'popAdvertisement'">
                <pop-advertisement :datas="slot"></pop-advertisement>
            </div>
            <template v-if="slot.type == 'card'">
                <member-card :datas="slot" :key="index">
                </member-card>
            </template>
            <div v-if="slot.type === 'hotelList'">
                <hotel-list :datas="slot"></hotel-list>
            </div>
        </div>
    </div>
    <IPhoneBottomHeight></IPhoneBottomHeight>
    <recommend></recommend>

    <div class="share-btn2" @click="showPoster" v-if="isShowShareBtn">
        生成<br>海报
    </div>
   
    <shareCommonFull :shareConfig="shareConfig" @cancel="closeShare" v-if="isShowShareBtn&&shareConfig.posterType=='full'" ref="share"></shareCommonFull>
    <shareCommon2 :shareConfig="shareConfig" @cancel="closeShare" v-else-if="isShowShareBtn&&shareConfig.posterCssType=='2'&&shareConfig.posterType=='custom'" ref="share"></shareCommon2>
    <shareCommon3 :shareConfig="shareConfig" @cancel="closeShare" v-else-if="isShowShareBtn&&shareConfig.posterCssType=='3'&&shareConfig.posterType=='custom'" ref="share"></shareCommon3>
    <shareCommon4 :shareConfig="shareConfig" @cancel="closeShare" v-else-if="isShowShareBtn&&shareConfig.posterCssType=='4'&&shareConfig.posterType=='custom'" ref="share"></shareCommon4>
    <shareCommon :shareConfig="shareConfig" @cancel="closeShare" v-else-if="isShowShareBtn" ref="share"></shareCommon>
</div>
</template>

<script>
import {
    setStorage,
    getStorage
} from "@/utils/wxuser";
import {
    baseUrl
} from "@/utils/baseUrl";
import {
  getUrlParams
} from "@/utils/index";
import api from "@/utils/api";
import CarouselSlide from "@/components/polymerization/CarouselSlide.vue";
import Category from "@/components/polymerization/Category.vue";
import Search from "@/components/polymerization/Search.vue";
import ScrollNotice from "@/components/polymerization/ScrollNotice.vue";
import Flashsale from "@/components/polymerization/Flashsale.vue";
import GoodsList from "@/components/polymerization/GoodsList.vue";
import Title from "@/components/polymerization/Title.vue";
import Navbar from "@/components/polymerization/Navbar.vue";
import HeadPic from "@/components/polymerization/HeadPic.vue";
import couponReceive from "@/components/polymerization/couponReceive.vue";
import recommend from "@/components/polymerization/recommend.vue";
import AuxiliaryLine from "@/components/polymerization/AuxiliaryLine.vue";
import Area from "@/components/polymerization/Area.vue";
import notice from "@/components/polymerization/notice.vue";
import Advertising from "@/components/polymerization/Advertising.vue";
import videoBox from "@/components/polymerization/video.vue";
import customerService from "@/components/polymerization/customerService.vue";
import Weather from "@/components/polymerization/Weather.vue";
import Login from "@/components/polymerization/Login.vue";
import plantGrass from "@/components/polymerization/plantGrass.vue";
import hotelGoods from "@/components/polymerization/hotelGoods.vue";
import sideBar from "@/components/polymerization/sideBar.vue";
import NavMenu from "@/components/polymerization/NavMenu.vue";
import groupList from "@/components/polymerization/groupList.vue";
import goodsType from "@/components/polymerization/goodsType.vue";
import hotelRoom from "@/components/polymerization/hotelRoom.vue";
import Elevator from "@/components/polymerization/Elevator.vue";
import rightsCenter from "@/components/polymerization/rightsCenter.vue";
import shareConfig from "@/components/polymerization/shareConfig.vue";
import telephone from "@/components/polymerization/telephone.vue";
import diyGoods from "@/components/polymerization/diyGoods.vue";
import guideLayer from '@/components/guideLayer';
import buttonGroup from '@/components/polymerization/buttonGroup';
import audioText from '@/components/polymerization/audioText';
import userAssets from "@/components/polymerization/userAssets";
import Activity from "@/components/polymerization/Activity.vue";
import popAdvertisement from '@/components/polymerization/popAdvertisement';
import memberCard from '@/components/polymerization/memberCard';
import shareCommon from "@/components/shareCommon";
import shareCommon2 from "@/components/shareCommon2";
import shareCommon3 from "@/components/shareCommon3";
import shareCommon4 from "@/components/shareCommon4";
import shareCommonFull from "@/components/shareCommonFull";
import hotelList from '@/components/polymerization/hotelList'
var config = {};
export default {
    data() {
        return {
            id: "",
            user: "",
            wxuser: "",
            page: "",
            haveBotnav: false,
            haveHeadPic: false,
            wxImg: "",
            officialName: "",
            isAttentionBox: false,
            timeOut: 5,
            officialAccountCountdown: "F",
            tips: false,
            bgStyle: '',
            code: false,
            closeAccountQrcode: 'F',
            share: {
                shareTitle: "",
                shareImg: "",
                shareDesc: "",
                background: "",
                backgroundImg: "",
            },
            shareConfig: {
                mainPicUrl: '',
                qrcodeUrl: '',
                info1: {
                    name: '',
                    title: '',
                    time: '',

                }
            },
            mainOpenid:getStorage("mainOpenid")||'',
            isShowShareBtn: "",
            receivedList:[]
        };
    },
    props: ["templateId", "templateInfo","hotelCode"],
    methods: {
        getCanReceivedList() {
            api
                .getCanReceivedList({
                    hotelGroupCode: config.hotelGroupCode,
                    hotelGroupId: config.hotelGroupId,
                    memberId: this.user.memberId || '',
                    hotelCode: config.hotelCode,
                    cardLevel: this.user.cardLevel || "",
                    couponCenterShow: 'R',
                    groupAll: 'T'
                })
                .then((res) => {
                    if (res.result == 1) {
                        this.receivedList = res.retVal

                    }

            });
        },
        showPoster() {
            this.$refs.share.isPoster = true;
        },
        isTipsQr() {
            this.tips = !this.tips
        },
        getData() {
            let info = JSON.parse(this.templateInfo);
            
            info = JSON.parse(info.show);
            var index = 0
            this.page = info.value;
            var title = '商城'

            if (!this.isShowShareBtn) {
                let poster =  JSON.parse(this.templateInfo).poster;
                if (poster && poster.posterTit) {

                    this.shareConfig.mainPicUrl = poster.posterPic
                    this.shareConfig.info1.title = poster.posterText
                    this.shareConfig.info1.activityTitle = poster.shareText
                    this.shareConfig.posterType = poster.posterType
                    this.shareConfig.posterCssType = poster.posterCssType
                    this.shareConfig.bottom = poster.bottom
                    this.shareConfig.right = poster.right
                    this.isShowShareBtn = true
                    if (!poster.isOpen || poster.isOpen != 'T') {
                        this.isShowShareBtn = false
                    }
                    if (poster.posterStartTime != '') {
                        this.shareConfig.info1.time = moment(poster.posterStartTime).format('YYYY-MM-DD HH:mm') + '至' + moment(
                            poster.posterEndTime).format('YYYY-MM-DD HH:mm')
                    } else {
                        this.shareConfig.info1.time = ''
                    }
                    if (poster.onlineStartTime != '') {
                        if (moment(poster.onlineEndTime).diff(moment(), 'seconds') < 0) {
                            this.isShowShareBtn = false
                        }
                        if (moment().diff(moment(poster.onlineStartTime), 'seconds') < 0) {
                            this.isShowShareBtn = false
                        }
                    } else {
                        this.isShowShareBtn = false
                    }
                    this.shareConfig.info1.name = poster.posterTit

                }
            }
            var hasRightsCenter = false
            this.page.forEach((item) => {
                if (item.type == 'rightsCenter') {
                    hasRightsCenter = true
                }
                if (item.type == 'elevator') {
                    item.items.forEach(component => {
                        component.datas = []

                        if (Array.isArray(component.position)) {
                            component.position.forEach(pos => {
                                this.page.forEach((item2) => {
                                    if (item2.name == pos) {
                                        component.datas.push(item2)
                                        item2.use = true
                                    }
                                })
                            })
                        } else {
                            this.page.forEach((item2) => {
                                if (item2.name == component.position) {
                                    // component.datas = item2
                                    component.datas.push(item2)
                                    item2.use = true

                                }
                            })
                        }

                    })
                }
            })
            if(hasRightsCenter){
                this.getCanReceivedList()
            }
            for (var i = 0; i < this.page.length; i++) {
                var item = this.page[i]
                if (item.use) {
                    this.page.splice(i, 1);
                    i--;
                }
                if (item.type == "config") {
                    this.share = item;

                    if (this.share.title != '') {
                        title = this.share.title
                    }

                    if (this.share.backType == "color") {
                        this.bgStyle = `background:${this.share.backgroundColor};`
                    } else {
                        this.bgStyle = `background: url(${this.share.backgroundImg}) 0 0;`
                    }
                }

                if (item.type == 'columnModule') {
                    if (item.items && item.isBottom) {
                        this.haveBotnav = true
                    }
                }
                if (item.type == 'image') {
                    item.index = index
                    index++
                }
                if (item.type == 'headPic') {
                    this.haveHeadPic = true
                }
                if (item.type == "config") {
                    this.share = item;
                    var shareInfo = {
                        code: "polymerization",
                        title: this.share.shareTitle, // 分享标题
                        link: this.shareConfig.url, // 分享链接
                        desc: this.share.shareDesc, // 
                        imgUrl: this.share.shareImg, // 分享图标
                    }
                    this.wechatShare(shareInfo)
                }
            }
            document.title = title
        },
        batchQueryShopConfig(cb) {
            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                configItem: "official_account_countdown,closeAccountQrcode",
                hotelCode: config.hotelCode,
            };
            api.batchQueryShopConfig(opt).then(res => {
                res.retVal.forEach(item => {
                    if (item.configItem == 'official_account_countdown') {
                        if (item.itemValue == "T") {
                            this.officialAccountCountdown = 'T';
                        }
                    }
                    if (item.configItem == 'closeAccountQrcode') {
                        if (item.itemValue && item.itemValue == "T") {
                            this.closeAccountQrcode = 'T';
                        }
                    }
                });

                cb && cb();
            });
        },
        myDistributionCenter(cb) {
            var opt = {
                openId: this.wxuser.openid,
                memberId: this.user.memberId,
                componentAppid: config.componentAppid,
                hotelGroupId: config.hotelGroupId,
                appid: config.appid,
                hotelGroupCode: config.hotelGroupCode,
            };
            api.isDistributor(opt).then((res) => {
                var shareUrl = `${window.location.origin}${baseUrl}#`;
                var query = this.$route.query;
                var path = "";

                for (var i in query) {
                    if (
                        i != "distributorOpenId" &&
                        i != "distributorId" &&
                        i != "openId" &&
                        i != "shareId" &&
                        i != "distributorOpenIdDis"
                    ) {
                        if (path == "") {
                            path = "/index&" + i + "=" + query[i];
                        } else {
                            path += "&" + i + "=" + query[i];
                        }
                    }
                }
                if (path == '') {
                    path = "/index"
                }
                if (this.mainOpenid != "") {
                    if (typeof this.mainOpenid == "object") {
                        this.mainOpenid.forEach((item) => {
                            if (item != "") {
                                this.mainOpenid = item;
                                setStorage('mainOpenid', this.mainOpenid)
                            }
                        });
                    }
                    path += "&distributorOpenId=" + this.mainOpenid
                    path += "&distributorOpenIdDis=" + this.wxuser.openid;
                } else {
                    path += "&distributorOpenId=" + this.wxuser.openid
                }
                if (res.result == 1) {
                    if (res.retVal && res.retVal.id) {
                        path += "&distributorId=" + res.retVal.id

                    }
                }
    
                // let params = getUrlParams(shareUrl);
                // let paramsList = Object.keys(params);
                this.shareConfig.url =  shareUrl + path.replace('&', '?')
                // if (paramsList.length > 0) {
                //     this.shareConfig.url = shareUrl + query
                // } else {
                //     this.shareConfig.url = shareUrl + '?toIndex=1'+query
                // }
                
                cb && cb();
            });
        },
        getWechatAccountInf() {
            try {
                var opt = {
                    openid: this.wxuser.openid,
                    appid: config.appid,
                    componentAppid: config.componentAppid
                }
                api.getWxUser(opt).then(res => {
                    if (res.result == 1) {
                        if (res.retVal.subscribe == undefined || res.retVal.subscribe != "1") {
                            api.wechatAccountInf(opt).then(res => {

                                if (res.result == 1) {
                                    this.officialName = res.retVal.name
                                    this.wxImg = "https://open.weixin.qq.com/qr/code?username=" + res.retVal.accountId
                                    this.isAttentionBox = true
                                    if (this.officialAccountCountdown == 'T') {
                                        var timer = setInterval(() => {
                                            this.timeOut--;
                                            if (this.timeOut <= 0) {
                                                this.isAttentionBox = false
                                                clearInterval(timer)
                                            }
                                        }, 1000)
                                    }

                                }
                            });
                        }
                    }
                });

            } catch (error) {

            }

        },
        isShowAttentionBox() {
            this.isAttentionBox = !this.isAttentionBox
            if (this.tips) {
                setStorage('closeQrCode', true)
            }
        },

    },
    components: {
        CarouselSlide,
        Category,
        ScrollNotice,
        Flashsale,
        GoodsList,
        Title,
        Navbar,
        HeadPic,
        couponReceive,
        Search,
        Area,
        notice,
        Advertising,
        customerService,
        videoBox,
        recommend,
        AuxiliaryLine,
        Weather,
        Login,
        plantGrass,
        hotelGoods,
        sideBar,
        NavMenu,
        groupList,
        goodsType,
        hotelRoom,
        Elevator,
        rightsCenter,
        shareConfig,
        telephone,
        diyGoods,
        guideLayer,
        buttonGroup,
        audioText,
        userAssets,
        Activity,
        popAdvertisement,
        memberCard,
        shareCommonFull,
        shareCommon,
        shareCommon2,
        shareCommon3,
        shareCommon4,
        hotelList
    },
    created() {
        config = getStorage("config");
        this.user = getStorage('user');
        this.wxuser = getStorage('wxuser');
    },
    mounted() {
        this.myDistributionCenter(() => {
            this.getData()
        })
        // this.batchQueryShopConfig(() => {
        //     if (!getStorage('closeQrCode') && this.closeAccountQrcode != 'T') {
        //         this.getWechatAccountInf()
        //     }
        // })

    }

}
</script>

<style lang="less">
.polymerization {
    .textarea img {
        width: 100%;
    }
}
</style><style lang="less" scoped>
.polymerization {
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
    background-size: 100% !important;
    .share-btn2 {
        position: fixed;
        bottom: 5.866667rem;
        transform: translateY(-50%);
        right: 0.32rem;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
        border: 1px solid #ffffff;
        width: 0.96rem;
        height: 0.96rem;
        line-height: 1.1;
        border-radius: 50%;
        color: #fff;
        font-size: 10px;
        font-family: PingFangSC-Semibold;

        img {
            width: 1.013333rem;
            height: 1.013333rem;
            pointer-events: none;
        }
    }

    .components_box {
        position: relative;
    }
    .haveHeadPic {
        height: 100vh;
    }

    .bgFixed {
        position: fixed;
        width: 100%;
        height: 100vh;
        background-size: cover !important;
        background-position-x: center !important;
        z-index: -1;
    }

    &.haveBotnav {
        padding-bottom: 1.76rem;
    }

    .bottomBoot {
        padding: 0.4rem 0.266667rem;

        .box {
            border-radius: 0.213333rem;
            background: #fff;
            padding: 0.213333rem 0.266667rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .info {
            display: flex;
            align-items: center;

            .logo {
                image {
                    width: 2.266667rem;
                    height: 0.906667rem;
                }
            }

            .name {
                height: 0.426667rem;
                line-height: 0.426667rem;
                padding-left: 0.4rem;
                border-left: 1px solid #333;
                font-size: 14px;
                color: #333333;
                font-weight: bold;
            }
        }

        .btn {
            border-radius: 8rpx;
            background: #0d468b;
            color: #ffffff;
            height: 0.533333rem;
            font-size: 12;
            line-height: 0.533333rem;
            padding: 0 0.346667rem;
        }
    }

    .attention-box {
        position: fixed;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        z-index: 999;

        .attention-container {
            position: absolute;
            left: 50%;
            top: 50%;
            background: url("https://xcx.ihotel.cn/mall/qrCode-bg3.png") no-repeat;
            background-size: contain;
            text-align: center;
            transform: translate(-50%, -55%);
            width: 8.67rem;
            height: 10.453333rem;
            box-sizing: border-box;

            img.qrcode {
                margin-top: 0.666667rem;
                width: 5.333333rem;
                height: 5.333333rem;
                // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
            }

            .close {
                position: absolute;
                top: 0;
                right: 0;
                padding: 0.266667rem;
                font-size: 12px;

                i {
                    font-size: 12px;
                }
            }

            .public-code-desc {
                margin-top: 0.533333rem;
                font-size: 16px;
                color: #333333;
            }

            .txt {
                line-height: 1.44rem;
                font-size: 14px;
                color: #666666;
                text-align: center;
                width: 100%;
            }

            .timeOut {
                position: absolute;
                bottom: 0.906667rem;
                font-size: 12px;
                color: #ffffff;
                text-align: center;
                width: 100%;
            }
        }

        .tips {
            position: absolute;
            bottom: 0.8rem;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #666666;
            justify-content: center;

            i {
                border: 1px solid #ddd;
                width: 18px;
                height: 18px;
                font-size: 18px;
                box-sizing: border-box;
                color: #666;
                margin-right: 0.186667rem;

                &.iconyixuanze {
                    border: 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index/activityIndex.vue